import { styled } from '@mui/material/styles';

import Rating from '@mui/material/Rating';

export const MaterialRating = styled(Rating, {
  shouldForwardProp: prop => prop !== 'compact',
})(({ theme, compact }) => ({
  fontSize: compact ? '32px' : '40px',
  color: theme.palette.blue.main,
  '& .MuiRating-iconEmpty': {
    color: theme.palette.colors.subdued,
  },
  '& .MuiRating-iconHover': {
    transform: 'scale(1.06)',
  },
}));
